import styled from "styled-components";

export const StyledChatbotButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;
  outline: none;
  border: none;
  box-sizing: border-box;
  padding: 0;
  width: 4rem;
  height: 4rem;
  background: linear-gradient(45deg, #57606a 0%, #afb8c1 100%);
  opacity: 0.4;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(1);
  transition: all 0.2s cubic-bezier(0.25, 1.5, 0.5, 1);
  p {
    font: var(--label-small-600);
    background-color: var(--text-gray-normal);
    width: calc(100% - 1rem);
    border-radius: 0.6rem;
    color: var(--pri-blue-4);
    position: relative;
    z-index: 10;
  }
  svg {
    position: relative;
    z-index: 10;
  }
  &:hover {
    width: 4rem;
    opacity: 1;
    animation: shadow 5s infinite linear;
    transform: scale(1.1);
    &::after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 50%;
      left: 50%;
      background: linear-gradient(
        0deg,
        rgb(131, 176, 251) 0%,
        rgb(32, 100, 246) 60%,
        rgb(19, 63, 158) 100%
      );
      animation: rotate 5s infinite linear;
      transition: all 0.2s ease;
      z-index: 1;
    }
  }
  &.active {
    opacity: 1;
  }
  &:active {
    transform: scale(0.9);
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
      filter: blur(0%);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
      filter: blur(100%);
    }
  }
  @keyframes shadow {
    0% {
      box-shadow: 0px 0px 10px 2px rgb(131, 176, 251);
    }
    25% {
      box-shadow: 0px 0px 10px 2px rgb(32, 100, 246);
    }
    50% {
      box-shadow: 0px 0px 10px 2px rgb(19, 63, 158);
    }
    75% {
      box-shadow: 0px 0px 10px 2px rgb(32, 100, 246);
    }
    100% {
      box-shadow: 0px 0px 10px 2px rgb(131, 176, 251);
    }
  }
`;
